export enum DiscussionType {
  discussion = "discussion",
  question = "question",
  idea = "idea",
  event = "event",
}
